/**
 * Phone with verification mark: green check (+ info icon whose hover title
 * shows when it was verified) or red cross when the number is not verified.
 * Admin-facing field used in the user and professional detail pages.
 */
export function PhoneField({
  phone,
  verified,
  verifiedAt,
}: {
  phone?: string;
  verified?: boolean;
  verifiedAt?: string;
}) {
  const verifiedAtLabel = verifiedAt
    ? new Date(verifiedAt).toLocaleString('it-IT', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : null;

  return (
    <div>
      <dt className="text-xs text-neutral-400">Telefono</dt>
      <dd className="mt-0.5 flex items-center gap-1.5 text-sm text-neutral-900">
        {phone ?? <span className="text-neutral-300">—</span>}
        {phone && (
          verified ? (
            <>
              <span
                title="Numero verificato"
                aria-label="Numero verificato"
                className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-emerald-100 text-emerald-600"
              >
                <svg aria-hidden="true" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                </svg>
              </span>
              {verifiedAtLabel && (
                <span
                  title={`Verificato il ${verifiedAtLabel}`}
                  aria-label={`Verificato il ${verifiedAtLabel}`}
                  className="inline-flex h-4 w-4 cursor-help items-center justify-center rounded-full text-neutral-400 hover:text-brand-teal"
                >
                  <svg aria-hidden="true" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                  </svg>
                </span>
              )}
            </>
          ) : (
            <span
              title="Numero non verificato"
              aria-label="Numero non verificato"
              className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-red-100 text-red-500"
            >
              <svg aria-hidden="true" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
              </svg>
            </span>
          )
        )}
      </dd>
    </div>
  );
}
